import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import TruckManagementPage from './TruckManagementPage';
import ShopManagementPage from './ShopManagementPage';
import MaintenanceTypesPage from './MaintenanceTypesPage';
import InspectionItemsAdminPage from './InspectionItemsAdminPage';

const TABS = [
  { key: 'trucks', label: 'Trucks', permission: 'manage_trucks', Component: TruckManagementPage },
  { key: 'shops', label: 'Shops', permission: 'manage_shops', Component: ShopManagementPage },
  { key: 'types', label: 'Maint. Types', permission: 'manage_maintenance', Component: MaintenanceTypesPage },
  // Inspection Items — admin/super_admin only via manage_maintenance.
  // Where is_critical lives (drivers never see this).
  { key: 'inspection_items', label: 'Inspection Items', permission: 'manage_maintenance', Component: InspectionItemsAdminPage },
];

export default function MaintenanceSetupPage({ embedded } = {}) {
  const { can } = useAuth();

  const visibleTabs = TABS.filter(t => can(t.permission));
  const [activeTab, setActiveTab] = useState(visibleTabs[0]?.key || '');

  const active = visibleTabs.find(t => t.key === activeTab);

  if (!visibleTabs.length) {
    return embedded ? <p>No config permissions.</p> : <div className="page-container"><p>You do not have permission to access maintenance setup.</p></div>;
  }

  const content = (
    <>
      <div className="setup-tabs">
        {visibleTabs.map(tab => (
          <button
            key={tab.key}
            className={`setup-tab${activeTab === tab.key ? ' active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {active && <active.Component />}
    </>
  );

  if (embedded) return content;

  return (
    <div className="page-container">
      <h1>Maintenance Setup</h1>
      {content}
    </div>
  );
}
